import { React, useState, useEffect, useRef } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Dialog } from "primereact/dialog";
import { useForm, Controller } from "react-hook-form";
import { RadioButton } from "primereact/radiobutton";
import InputTextElement from "../../../../Components/UiComponents/InputTextElement";
import "../../../../../src/App.css";
import _ from "lodash";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
// UI components
import MultiSelectElement from "../../../../Components/UiComponents/MultiSelectElement";
// Services
import { get } from "../../../../Services/customerServices";
import { list } from "../../../../Services/branchService";
import { create } from "../../../../Services/checklistService";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import DropdownElement from "../../../../Components/UiComponents/DropdownElement";
import Loader from "../../../../Components/UiComponents/Loader";

export default function CreateNewCheckList(props) {
  const [winWorkStageOtps, setWinWorkStageOtps] = useState([]);
  const [sectorV1Opts, setSectorV1Opts] = useState([]);
  const [businessUnitOpts, setBusinessUnitOpts] = useState([]);
  const [servicesOpts, setServicesOpts] = useState([]);
  const [regionOpts, setRegionOpts] = useState([]);
  const [roUsersOpts, setRoUsersOpts] = useState([]);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const toastRef = useRef();

  useEffect(() => {
    getCustomer();
    getBranchList();
  }, [props?.customerId, props?.customerControlFields]);

  // Function to get customer reference data.
  const getCustomer = async () => {
    try {
      if (props.customerId === null) {
        return;
      }
      if (props?.customerId) {
        const customer = await get(props.customerId);
        if (customer) {
          // WinWorkStage
          const referenceData = customer?.data?.reference_data?.find(
            (item) => item.option_names === "WinWorkStage"
          );
          if (referenceData && referenceData?.option_choice) {
            const activeOptions = referenceData.option_choice.filter(
              (option) => option.status === "active"
            );
            setWinWorkStageOtps(activeOptions);
          }

          // SectorV1
          const refDataSectorV1 = customer?.data?.reference_data?.find(
            (item) => item.option_names === "SectorV1"
          );
          if (refDataSectorV1 && refDataSectorV1.option_choice) {
            const activeOptions = refDataSectorV1.option_choice.filter(
              (option) => option.status === "active"
            );
            activeOptions.unshift({ label: "All", status: "active", score: 0 });
            setSectorV1Opts(activeOptions);
          }

          // // BusinessUnit
          const refDataBusinessUnit = customer?.data?.reference_data?.find(
            (item) => item.option_names === "BusinessUnit"
          );
          if (refDataBusinessUnit && refDataBusinessUnit.option_choice) {
            const activeOptions = refDataBusinessUnit.option_choice.filter(
              (option) => option.status === "active"
            );
            activeOptions.unshift({ label: "All", status: "active", score: 0 });
            setBusinessUnitOpts(activeOptions);
          }

          // // Services
          const referenceDataServices = customer?.data?.reference_data?.find(
            (item) => item.option_names === "Services"
          );
          if (referenceDataServices && referenceDataServices.option_choice) {
            const activeOptions = referenceDataServices.option_choice.filter(
              (option) => option.status === "active"
            );
            activeOptions.unshift({ label: "All", status: "active", score: 0 });
            setServicesOpts(activeOptions);
          }

          // // Region
          const referenceDataRegion = customer?.data?.reference_data?.find(
            (item) => item.option_names === "Region"
          );
          if (referenceDataRegion && referenceDataRegion.option_choice) {
            const activeOptions = referenceDataRegion.option_choice.filter(
              (option) => option.status === "active"
            );
            activeOptions.unshift({ label: "All", status: "active", score: 0 });
            setRegionOpts(activeOptions);
          }

          // // RO Users
          const referenceDataRoUser = customer?.data?.reference_data?.find(
            (item) => item.option_names === "BDLongShotRole"
          );
          if (referenceDataRoUser && referenceDataRegion.option_choice) {
            let optionList = [];
            for (var i = 0; i < referenceDataRoUser.option_choice.length; i++) {
              optionList.push({
                id: i + 1,
                label: referenceDataRoUser.option_choice[i].label,
              });
            }
            setRoUsersOpts(optionList);
          }
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  // Function to get branches.
  const getBranchList = async () => {
    try {
      if (props.customerId === null) {
        return;
      }
      if (props?.customerId) {
        const branch = await list(props.customerId, "branch_name", -1);
        if (branch) {
          const allBranches = branch.data.branch;
          let optionList = allBranches.map((item) => ({
            id: item._id,
            label: item.branch_name,
          }));
          setBranches(optionList);
        }
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    }
  };

  // Function to create new checklist
  const onSubmit = async (checkData) => {
    var newCheckData = checkData;
    const branch = branches.find(branch => branch.id === props.branchIdFromLS.branch_id);
    newCheckData.customer_id = props?.customerId;
    newCheckData.accountable_users = {
      role: checkData.accountable_users?.label,
    };
    newCheckData.contributing_users = checkData.contributing_users?.map(
      (user) => ({
        role: user?.label,
      })
    );
    newCheckData.informed_users = checkData.informed_users?.map((user) => ({
      role: user?.label,
    }));
    newCheckData.responsible_users = checkData.responsible_users?.map(
      (user) => ({
        role: user?.label,
      })
    );
    newCheckData.sector = checkData?.sector?.label;
    newCheckData.business_unit = checkData?.business_unit?.label;
    newCheckData.winwork_display = checkData?.winstage?.text;
    newCheckData.winstage = checkData?.winstage?.label;

    newCheckData.opportunity_type = checkData?.opportunity_type?.label;
    newCheckData.region = checkData?.region?.label;
    newCheckData.branch = checkData?.branch?.label || branch.label;

    try {
      setLoading(true)
      const response = await create(newCheckData);
      if (response && response?.status === 200) {
        toastRef.current.showToast({
          type: "success",
          message: `${props?.customerControlFields &&
            props?.customerControlFields.tabs[9]?.display_name
            } Created Successfully`,
        });
        clearForm();
      } else {
        toastRef.current.showToast({
          type: "error",
          message: "Error",
        });
      }
    } catch (error) {
      toastRef.current.showToast({
        type: 'error',
        message: 'An error occurred. Please try again or Contact Admin.'
      });
    } finally {
      closePopup();
      setLoading(false)
    }
  };

  const closePopup = () => {
    props?.onHide();
  };

  const clearForm = () => {
    reset();
  };

  const renderFooter = (a) => {
    return (
      <div className="cancel-footer">
        <div className='align-center justify-end pb-0'>
          <ButtonElement type="submit" label="Create" className="save-button" onClick={handleSubmit(onSubmit)} />
        </div>
      </div>
    );
  }

  return (
    <div>
      <ToastElement ref={toastRef} />
      <Loader loading={loading} />
      <Dialog
        header={`New ${props?.customerControlFields &&
          props?.customerControlFields.tabs[9]?.display_name
          }`}
        visible={props?.visible}
        position={props?.position}
        className="width-46"
        onHide={() => {
          closePopup();
          clearForm();
        }}
        footer={renderFooter()}
        draggable={false}
      >
        <div className="new-field">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props?.customerControlFields &&
                    props?.customerControlFields.tabs[9].tables[0].headers[0]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="checklist_item"
                  control={control}
                  rules={{
                    required:
                      "Checklist Item must be below 500 characters in alphanumeric",
                    maxLength: {
                      value: 500,
                      message:
                        "Checklist Item must be below 500 characters in alphanumeric",
                    },
                  }}
                  render={({ field }) => (
                    <InputTextElement
                      id="checklist_item"
                      placeholder="Text"
                      {...field}
                    />
                  )}
                />
                {errors.checklist_item && (
                  <small
                    className="text-red-500 ml-1 mt-1 color_red_new"
                  >
                    {errors.checklist_item.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mt-0 mb-0" >
              <div className="col-md-4 text-left pl-0">
                <label className="form-label text-left">
                  {props?.customerControlFields &&
                    props?.customerControlFields.tabs[9].tables[0].headers[1]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="checklist_type"
                  control={control}
                  rules={{ required: "Prompt Type is required" }}
                  render={({ field }) => (
                    <>
                      <RadioButton
                        inputId="wow"
                        value="Ways of Working"
                        onChange={(e) => field.onChange(e.value)}
                        checked={field.value === "Ways of Working"}
                      />
                      <label htmlFor="wow" className="p-radiobutton-label mr-5">
                        {props.customerControlFields?.tabs[9]?.tables[0]?.headers.find(item => item.header_name === "Ways of Working").display_name}
                      </label>
                      <RadioButton
                        inputId="review"
                        value="Review"
                        onChange={(e) => field.onChange(e.value)}
                        checked={field.value === "Review"}
                      />
                      <label htmlFor="review" className="p-radiobutton-label mr-5">
                        {props.customerControlFields?.tabs[9]?.tables[0]?.headers.find(item => item.header_name === "Review").display_name}
                      </label>
                      <RadioButton
                        inputId="gateway"
                        value="Gateway"
                        onChange={(e) => field.onChange(e.value)}
                        checked={field.value === "Gateway"}
                      />
                      <label htmlFor="gateway" className="p-radiobutton-label">
                        {props.customerControlFields?.tabs[9]?.tables[0]?.headers.find(item => item.header_name === "Gateway").display_name}
                      </label>
                    </>
                  )}
                />
                {errors.checklist_type && (
                  <small
                    className="text-red-500 color-red"
                  >
                    {errors.checklist_type.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mt-0 mb-0" >
              <div className="col-md-4 text-left pl-0">
                <label className="form-label text-left">
                  {props?.customerControlFields &&
                    props?.customerControlFields.tabs[0].tables[0].headers[0]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="winstage"
                  control={control}
                  rules={{ required: "Stage is required" }}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => (
                    <DropdownElement
                      onChange={(e) => field.onChange(e.value)}
                      id="winstage"
                      options={(winWorkStageOtps != undefined && winWorkStageOtps.length > 0) ? winWorkStageOtps : []}
                      optionLabel="text"
                      placeholder="-- Please select --"
                      className="w-full"
                      {...field}
                      maxSelectedLabels={1}
                    />
                  )}
                />
                {errors.winstage && (
                  <small className="text-red-500 ml-1" style={{ color: "red" }}>
                    {errors.winstage.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mt-0 mb-0">
              <div className="col-md-4 text-left pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[9].tables[0].headers[6]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="sector"
                  control={control}
                  rules={{ required: "Sector is required" }}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => (
                    <DropdownElement
                      onChange={(e) => field.onChange(e.value)}
                      id="sector"
                      options={(sectorV1Opts != undefined && sectorV1Opts.length > 0) ? sectorV1Opts : []}
                      optionLabel="label"
                      placeholder="-- Please select --"
                      className="w-full"
                      {...field}
                      maxSelectedLabels={1}
                    />
                  )}
                />
                {errors.sector && (
                  <small className="text-red-500 ml-1" style={{ color: "red" }}>
                    {errors.sector.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mt-0 mb-0">
              <div className="col-md-4 text-left pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[8].tables[0].headers[11]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="business_unit"
                  control={control}
                  rules={{ required: 'Business Unit is required' }}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => (
                    <DropdownElement
                      onChange={(e) => field.onChange(e.value)}
                      id="business_unit"
                      options={(businessUnitOpts != undefined && businessUnitOpts.length > 0) ? businessUnitOpts : []}
                      optionLabel="label"
                      placeholder="-- Please select --"
                      className="w-full"
                      {...field}
                      maxSelectedLabels={1}
                    />
                  )}
                />
                {errors.business_unit && (
                  <small className="text-red-500" style={{ color: "red" }}>
                    {errors.business_unit.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mb-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props?.customerControlFields &&
                    props?.customerControlFields.tabs[8].tables[0].headers[12]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="opportunity_type"
                  control={control}
                  rules={{ required: 'Project Type is required' }}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => (
                    <DropdownElement
                      onChange={(e) => field.onChange(e.value)}
                      id="opportunity_type"
                      options={(servicesOpts != undefined && servicesOpts.length > 0) ? servicesOpts : []}
                      optionLabel="label"
                      placeholder="-- Please select --"
                      className="w-full"
                      {...field}
                      maxSelectedLabels={1}
                    />
                  )}
                />
                {errors.opportunity_type && (
                  <small className="text-red-500" style={{ color: "red" }}>
                    {errors.opportunity_type.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props?.customerControlFields &&
                    props?.customerControlFields.tabs[8].tables[0].headers[13]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="region"
                  control={control}
                  style={{ innerHeight: 10 }}
                  rules={{ required: "Region is required" }}
                  render={({ field }) => (
                    <DropdownElement
                      onChange={(e) => field.onChange(e.value)}
                      id="region"
                      options={(regionOpts != undefined && regionOpts.length > 0) ? regionOpts : []}
                      optionLabel="label"
                      placeholder="-- Please select --"
                      className="w-full"
                      {...field}
                      maxSelectedLabels={1}
                    />
                  )}
                />
                {errors.region && (
                  <small className="text-red-500" style={{ color: "red" }}>
                    {errors.region.message}
                  </small>
                )}
              </div>
            </div>
            { props.havingBranch && props.branchIdFromLS.branch_key == 'main' &&
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[8].tables[0].headers[14]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="branch"
                  control={control}
                  rules={{ required: "Branch is required" }}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => (
                    <DropdownElement
                      onChange={(e) => field.onChange(e.value)}
                      id="branch"
                      options={(branches != undefined && branches.length > 0) ? branches : []}
                      optionLabel="label"
                      placeholder="-- Please select --"
                      className="w-full"
                      {...field}
                      maxSelectedLabels={1}
                    />
                  )}
                />
                {errors.branch && (
                  <small className="text-red-500" style={{ color: "red" }}>
                    {errors.branch.message}
                  </small>
                )}
              </div>
            </div>
            }
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[9].tables[0].headers[7]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="responsible_users"
                  control={control}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => (
                    <MultiSelectElement
                      id="responsible_users"
                      {...field}
                      name="responsible_users"
                      options={roUsersOpts}
                      placeholder="-- Please select --"
                      maxSelectedLabels={1}
                      onChangeValue={(e) => field.onChange(e.value)}
                      className="w-full"
                    />
                  )}
                />
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[9].tables[0].headers[8]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="accountable_users"
                  control={control}
                  rules={{ required: "Accountable User is required" }}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => (
                    <DropdownElement
                      onChange={(e) => field.onChange(e.value)}
                      id="accountable_users"
                      options={(roUsersOpts != undefined && roUsersOpts.length > 0) ? roUsersOpts : []}
                      optionLabel="label"
                      placeholder="-- Please select --"
                      className="w-full"
                      {...field}
                      maxSelectedLabels={1}
                    />
                  )}
                />
                {errors.accountable_users && (
                  <small className="text-red-500 ml-1" style={{ color: "red" }}>
                    {errors.accountable_users.message}
                  </small>
                )}
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[9].tables[0].headers[9]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="contributing_users"
                  control={control}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => (
                    <MultiSelectElement
                      id="contributing_users"
                      {...field}
                      name="contributing_users"
                      options={roUsersOpts}
                      placeholder="-- Please select --"
                      maxSelectedLabels={1}
                      onChangeValue={(e) => field.onChange(e.value)}
                      className="w-full"
                    />
                  )}
                />
              </div>
            </div>
            <div className="form-group row align-items-center mb-0 mt-0">
              <div className="col-md-4 pl-0">
                <label className="form-label text-left">
                  {props.customerControlFields &&
                    props.customerControlFields.tabs[9].tables[0].headers[10]
                      ?.display_name}
                </label>
              </div>
              <div className="col pr-0">
                <Controller
                  name="informed_users"
                  control={control}
                  style={{ innerHeight: 10 }}
                  render={({ field }) => (
                    <MultiSelectElement
                      id="informed_users"
                      {...field}
                      name="informed_users"
                      options={roUsersOpts}
                      placeholder="-- Please select --"
                      maxSelectedLabels={1}
                      onChangeValue={(e) => field.onChange(e.value)}
                      className="w-full"
                    />
                  )}
                />
              </div>
            </div>
          </form>
        </div>
      </Dialog>
    </div>
  );
}
